var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenClaw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lobster-gradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ff4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#991b1b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 10 C30 10 15 35 15 55 C15 75 30 95 45 100 L45 110 L55 110 L55 100 C55 100 60 102 65 100 L65 110 L75 110 L75 100 C90 95 105 75 105 55 C105 35 90 10 60 10Z",
    fill: "url(#lobster-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45 C5 40 0 50 5 60 C10 70 20 65 25 55 C28 48 25 45 20 45Z",
    fill: "url(#lobster-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 45 C115 40 120 50 115 60 C110 70 100 65 95 55 C92 48 95 45 100 45Z",
    fill: "url(#lobster-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15 Q35 5 30 8",
    stroke: "#ff4d4d",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15 Q85 5 90 8",
    stroke: "#ff4d4d",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 35,
    r: 6,
    fill: "#050810"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 35,
    r: 6,
    fill: "#050810"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 34,
    r: 2.5,
    fill: "#00e5cc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 34,
    r: 2.5,
    fill: "#00e5cc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenClaw);
export default __webpack_public_path__ + "static/media/open-claw.e90e84de195bfe2423b5f6a2396e10bf.svg";
export { ForwardRef as ReactComponent };